export function showPopup(popup, entityType, id) {
    return (dispatch) => {
        dispatch({
            type: 'POPUP:SHOW',
            popup,
            entityType,
            id,
        });
    };
}

export function showPopupNew({
    popup,
    entityType,
    id,
    onClosePopup,
    redirectTo,
    renewalDate,
    referringSurface,
    gatedFeature,
    prismicTitle,
}) {
    return (dispatch) => {
        dispatch({
            type: 'POPUP:SHOW',
            popup,
            entityType,
            id,
            onClosePopup,
            redirectTo,
            renewalDate,
            referringSurface,
            gatedFeature,
            prismicTitle,
        });
    };
}

export function closePopup(popup) {
    return (dispatch) => {
        dispatch({
            type: 'POPUP:CLOSE',
            popup,
        });
    };
}
